import { createSelector } from "reselect"
import { get } from "lodash"
import { getIsOpPro } from "modules/account-root/selectors"
import { computeDatasetEntitlementsTabs } from "helpers/permissions/tabs"
import { getPath, getRoute } from "selectors/urls"

export const getTokenPermissions = (_, props) => get(props, "tokenPermissions.token.resourcePermissions")
export const getResources = (_, props) => get(props, "resources.resources")

export const getTabs = createSelector(
  [getRoute, getPath, getIsOpPro],
  computeDatasetEntitlementsTabs,
)
